import React from "react";
import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { CONTACT_INFO } from "../lib/catalog";

export const Footer = () => {
  return (
    <footer
      id="kontak"
      data-testid="footer-section"
      className="bg-[#1A2B29] text-[#F9F8F6] pt-24 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="hp-divider" />
              <span className="overline text-[#C4A661]">Kontak</span>
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl font-light tracking-tight leading-[1.05]">
              Konsultasi langsung melalui <em className="italic text-[#C4A661]">kontak resmi</em>.
            </h2>
            <p className="mt-6 text-[#D5D9D8] leading-relaxed text-base">
              Untuk konsultasi dan janji temu, hubungi kantor melalui WhatsApp atau email.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            <div className="bg-[#1A2B29] p-7">
              <Phone size={22} className="text-[#C4A661] mb-5" strokeWidth={1.4} />
              <div className="text-[#C4A661] uppercase tracking-[0.16em] text-[10px] font-semibold mb-2">
                Telepon / WhatsApp
              </div>
              <div
                data-testid="footer-whatsapp"
                className="font-serif text-3xl text-[#F9F8F6]"
              >
                {CONTACT_INFO.whatsappLabel}
              </div>
              <div
                data-testid="footer-whatsapp-cta"
                className="btn-primary mt-7 pointer-events-none select-text"
              >
                <MessageCircle size={16} />
                Simpan nomor
              </div>
            </div>

            <div className="bg-[#1A2B29] p-7">
              <Mail size={22} className="text-[#C4A661] mb-5" strokeWidth={1.4} />
              <div className="text-[#C4A661] uppercase tracking-[0.16em] text-[10px] font-semibold mb-2">
                Email
              </div>
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                data-testid="footer-email"
                className="text-[#F9F8F6] hover:text-[#C4A661] transition-colors break-all"
              >
                {CONTACT_INFO.email}
              </a>
            </div>

            <div className="bg-[#1A2B29] p-7">
              <MapPin size={22} className="text-[#C4A661] mb-5" strokeWidth={1.4} />
              <div className="text-[#C4A661] uppercase tracking-[0.16em] text-[10px] font-semibold mb-2">
                Alamat Kantor
              </div>
              <div className="text-[#F9F8F6] text-sm leading-relaxed">
                {CONTACT_INFO.addressLines.map((line) => (
                  <React.Fragment key={line}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="bg-[#1A2B29] p-7">
              <Clock size={22} className="text-[#C4A661] mb-5" strokeWidth={1.4} />
              <div className="text-[#C4A661] uppercase tracking-[0.16em] text-[10px] font-semibold mb-2">
                Jam Operasional
              </div>
              <div className="text-[#F9F8F6] text-sm leading-relaxed">
                {CONTACT_INFO.officeHours.map((line) => (
                  <React.Fragment key={line}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#9CA8A6]">
          <div className="font-serif text-base text-[#F9F8F6]">
            Helen Parlista, S.H, M.Kn - Notaris &amp; PPAT
          </div>
          <div className="uppercase tracking-[0.18em]">
            &copy; {new Date().getFullYear()} - Semua Hak Dilindungi
          </div>
        </div>
      </div>
    </footer>
  );
};
